import { Table } from '@dixa/lib-shared-habla';
import { PropsWithChildren } from 'lib-shared-types-utils';

import { QueueDashboardMetricTitle } from '../metric/components/title/queueDashboardMetricTitle';

import styles from './queueDashboardTable.module.scss';

export const QueueDashboardTable = ({
  children,
}: PropsWithChildren): JSX.Element => {
  return (
    <Table stickyHeader headerWithBackground={false} className={styles.table}>
      <Table.Thead className={styles.thead}>
        <Table.Tr>
          <Table.Th width="18%">Name</Table.Th>

          <Table.Th width="18%">
            <QueueDashboardMetricTitle
              metricType="agent_presence"
              variant="3"
            />
          </Table.Th>

          <Table.Th width="18%">
            <QueueDashboardMetricTitle
              metricType="pending_conversations"
              variant="3"
            />
          </Table.Th>

          <Table.Th width="12%">
            <QueueDashboardMetricTitle metricType="queued_time" variant="3" />
          </Table.Th>

          <Table.Th width="16%">
            <QueueDashboardMetricTitle
              metricType="daily_conversations"
              variant="3"
            />
          </Table.Th>

          <Table.Th width="15%">
            <QueueDashboardMetricTitle metricType="response_time" variant="3" />
          </Table.Th>

          <Table.Th width="32px"></Table.Th>
        </Table.Tr>
      </Table.Thead>

      <Table.Tbody>{children}</Table.Tbody>
    </Table>
  );
};
